import React, {Component} from 'react';
import PropTypes from "prop-types";

import Modal from "../Modal";
import UserApi from "../../api/UserApi";
import LostPasswordButton from "./LostPasswordButton";
import SignUpButton from "./SignUpButton";
import SocialLogin from "./SocialLogin";
import Icon from "../Icon";

class SignInOverlay extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    onSignIn: PropTypes.func,
    onClose: PropTypes.func,
    type: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      hidden: false
    };
  }

  onSignIn(e) {
    e.preventDefault();

    UserApi.login(document.getElementById('login-email').value, document.getElementById('login-password').value).then(() => {
      if (typeof this.props.onSignIn === "function") {
        this.props.onSignIn();
      }
    }).catch(e => {
      if (e.response.data.error) {
        this.setState({ error: e.response.data.error });
      }
    });

    return false;
  }

  onModalHidden() {
    this.setState({ hidden: true });
  }

  onModalShown() {
    this.setState({ hidden: false });
  }

  render() {
    const { visible } = this.props;
    const { error, hidden } = this.state;

    return (
      <Modal
        visible={visible}
        hidden={hidden}
        onClose={this.props.onClose}
        header={<h5>Login</h5>}
        footer={
          <SignUpButton className={"register-button"} onOpen={this.onModalHidden.bind(this)} onClose={this.onModalShown.bind(this)} onSignUp={this.props.onSignIn}>
            No account? Sign up here
          </SignUpButton>
        }
      >
        <div className={'user-form'}>
          <div className={'row no-gutters'}>
            <div className={'col-4'}>
              <div className={'social-logins'}>
                <h5 className={'mb-3 text-center'}>Use a Social Provider</h5>

                <SocialLogin type={"google"} />
                <SocialLogin type={"discord"} />
                <SocialLogin type={"simply_hentai"} />
              </div>
            </div>
            <div className={'col-8'}>
              <form onSubmit={this.onSignIn.bind(this)}>
                {error && <div className={'error-messages'}>{error}</div>}

                <div className={'form-group'}>
                  <label htmlFor={'login-email'}>E-Mail-Address</label>
                  <input type={'text'} name={"email"} id={'login-email'} className={'form-control'} />
                </div>

                <div className={'form-group'}>
                  <label htmlFor={'login-password'}>Password</label>
                  <input type={'password'} name={"password"} id={'login-password'} className={'form-control'} />
                </div>

                <button className={'btn btn-primary btn-block icon-right mb-3'}>
                  Login <Icon icon={'arrow-right'}/>
                </button>
              </form>

              <LostPasswordButton className={'lost-password mt-3'} onOpen={this.onModalHidden.bind(this)} onClose={this.onModalShown.bind(this)}>
                Lost Password?
              </LostPasswordButton>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default SignInOverlay;